export default (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate());
